import { ProviderType } from '../../gql/types';

// Residency helpers for the Docs availability panel. `in_house` is the only residency-safe
// (Australian) provider type — every other type is offshore. This mirrors the backend's
// residency model in AiProxy.Routing.Override (in_house is the single non-offshore type).

/** True when a provider type keeps traffic on owned, in-country infrastructure. */
export function isResidencySafe(type: ProviderType): boolean {
  return type === ProviderType.InHouse;
}

/**
 * A short residency label for a provider. Prefers the provider's declared `dataResidency`
 * (e.g. "AU", "US") when present; otherwise falls back to a coarse safe/offshore descriptor.
 */
export function residencyLabel(
  type: ProviderType,
  dataResidency?: string | null,
): string {
  if (dataResidency && dataResidency.trim() !== '') {
    return dataResidency.toUpperCase();
  }
  return isResidencySafe(type) ? 'In-country' : 'Offshore';
}
